import { Button, MenuItem, Popover } from "@material-ui/core";
import { FC, useState } from "react";

export interface GroupByOption {
  value: string;
  label: string;
}

interface GroupByToggleButtonProps {
  options: GroupByOption[];
  value: string;
  onChange: (value: string) => void;
  label?: string;
}

const GroupByToggleButton: FC<GroupByToggleButtonProps> = ({
  options,
  value,
  onChange,
  label = "Group By",
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <Button
        variant="contained"
        size="small"
        color="primary"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        title={label}
        disableElevation
      >
        {label}
      </Button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <div style={{ padding: "4px 0" }}>
          {options.map((opt) => (
            <MenuItem
              key={opt.value}
              selected={value === opt.value}
              onClick={() => {
                onChange(value === opt.value ? "" : opt.value);
                setAnchorEl(null);
              }}
            >
              {opt.label}
            </MenuItem>
          ))}
        </div>
      </Popover>
    </>
  );
};

export default GroupByToggleButton;
